const state = {
  base: {
    peiId: null,
    areaId: null,
    peiGgradeId: null,
    studentSieId: null,
    academicYearId: null,
    programServiceAreaId: null
  },
  sysParameters: {
    PEIStrengthsAndNeedsCatalog: null,
    ShowSummaryResultInPei: null,
    ShowCompensatoryServicesInPei: null
  },
  catalogueOptions: {
    skills: [],
    necessities: [],
    grades: [],
    availableProcedures: [],
    adequacy: [],
    terms: [],
    suitabilities: [],
    instruments: [],
    availableStrengths: [],
    subAreas: []
  },
  resources: {},
  selectedArea: {},
  selectedNecessities: [],
  selectedStrengthsNecessities: [],
  createdGoals: [],
  selectedProcedures: [],
  selectedStrengths: [],
  selectedSubAreas: []
};

export default state;
